import moment from "moment";

export const BASE_POSTER_URL = "https://image.tmdb.org/t/p/w500";

export const BASE_CAST_URL = "https://image.tmdb.org/t/p/w185";

export const BASE_PERSON_URL = "https://image.tmdb.org/t/p/w500";

export const BASE_BACKDROP_URL = "https://image.tmdb.org/t/p/original";

export const NO_CAST_IMG =
  "https://pecb.com/conferences/wp-content/uploads/2017/10/no-profile-picture.jpg";

export const NO_POSTER_IMG = "https://static-assets.noovie.com/images/no-poster.png";

export const NO_BACKDROP_IMG =
  "https://imgcld.yatra.com/ytimages/image/upload/t_mobiledetailsimg/v1/default.jpg";

export const NO_PEOPLE_IMG =
  "https://sprucegrovelandscaping.com/wp-content/uploads/2016/04/Photo-Not-Available.jpg";

export const TODAY = moment().format("YYYY-MM-DD");
export const NEXTMONTH = moment()
  .add(1, "M")
  .format("YYYY-MM-DD");
export const PREVMONTH = moment()
  .subtract(1, "M")
  .format("YYYY-MM-DD");
